require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./es-mx-project-recursos-para-la-incidencia.json") })
        }
      }, "path---es-mx-project-recursos-para-la-incidencia");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---es-mx-project-recursos-para-la-incidencia!./.cache/json/es-mx-project-recursos-para-la-incidencia.json
// module id = 901
// module chunks = 231608221292675